"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayBuffer = void 0;
var hasArrayBuffer = typeof ArrayBuffer === "function";
var objToString = Object.prototype.toString;
// Taken from: https://github.com/fengyuanchen/is-array-buffer/blob/master/src/index.js
function isArrayBuffer(value) {
    return (hasArrayBuffer &&
        (value instanceof ArrayBuffer || objToString.call(value) === "[object ArrayBuffer]"));
}
exports.isArrayBuffer = isArrayBuffer;
